import HttpError from "@helper/httpError";

export const callApi = (url: string, params = {}, httpMethod: string = 'GET') => {
  try {
    const _url = new URL(url, url.toLowerCase().startsWith('http://') || url.toLowerCase().startsWith('https://') ? undefined : document.location.origin)
    Object.entries(params).forEach(([k, v]) => {
      _url.searchParams.append(k, v as string)
    })

    if (!['GET', 'POST', 'PUT', 'DELETE'].includes(httpMethod.toUpperCase())) {
      throw new Error('Invalid httpMethod');
    }

    return fetch(_url.toString(), { method: httpMethod })
      .then(response => {
        if (!response.ok)
        {
          if(response.status === 401) {
            throw new HttpError(response.status, 'An error occurred');
          }
          return Promise.reject(response.status);
        }
        return response.text();
      })
      .then(data => !!data ? JSON.parse(data) : null)
      .catch(e => {
        console.error(e);
        if (e instanceof HttpError) {
          throw e;
        }
        return Promise.reject(e);
      });
  } catch (e) {
    console.error(e);
    if (e instanceof HttpError) {
      throw e;
    }
    return Promise.reject(e);
  }
}
